// extracted by mini-css-extract-plugin
export default {"container":"NoInternetBar_container__16UI0","closeBtn":"NoInternetBar_closeBtn__v9TPV"};